import { NgModule } from '@angular/core';
import { SearchPipe } from './search-pipe';
import { SafeHtmlPipe } from './safehtml-pipe';
import { SafeUrlPipe } from './safeurl-pipe';
import { FaqPipe } from './faq-pipe';

@NgModule({
    declarations: [
        SearchPipe,
        SafeHtmlPipe,
        SafeUrlPipe,
        FaqPipe

    ],
    imports     : [],
    exports     : [
        SearchPipe,
        SafeHtmlPipe,
        SafeUrlPipe,
        FaqPipe
    ]
})
export class PipesModule
{
}
